import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, createCommentVNode as _createCommentVNode, renderSlot as _renderSlot, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-743e67e9"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "song-meta" }
const _hoisted_2 = ["src", "alt"]
const _hoisted_3 = { class: "song-title" }
const _hoisted_4 = { class: "rating" }
const _hoisted_5 = { class: "rating-hearts" }
const _hoisted_6 = ["mask"]
const _hoisted_7 = {
  key: 0,
  class: "meta"
}
const _hoisted_8 = { key: 0 }
const _hoisted_9 = { class: "muted" }
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("svg", { class: "icon-add" }, [
  /*#__PURE__*/_createElementVNode("use", { href: "#icon-plus" })
], -1))
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "fancy" }, "stem ook!", -1))
const _hoisted_12 = {
  key: 1,
  class: "icon-change"
}
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("use", { href: "#icon-chevron-down" }, null, -1))
const _hoisted_14 = [
  _hoisted_13
]
const _hoisted_15 = {
  key: 0,
  class: "modal",
  ref: "modal"
}
const _hoisted_16 = { class: "modal-header" }
const _hoisted_17 = { class: "song-meta" }
const _hoisted_18 = ["src", "alt"]
const _hoisted_19 = { class: "song-title" }
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "jouw beoordeling...", -1))
const _hoisted_21 = { class: "modal-content" }
const _hoisted_22 = { class: "rating-hearts" }
const _hoisted_23 = ["onClick"]
const _hoisted_24 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("use", { href: "#icon-heart" }, null, -1))
const _hoisted_25 = [
  _hoisted_24
]
const _hoisted_26 = { class: "modal-actions" }
const _hoisted_27 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, null, -1))
const _hoisted_28 = { key: 0 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("li", {
      class: "rating-item",
      onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.handleClick && _ctx.handleClick(...args)))
    }, [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("img", {
          src: `${_ctx.song.albumart.url}?w=150`,
          alt: _ctx.song.title
        }, null, 8, _hoisted_2),
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("h4", null, _toDisplayString(_ctx.song.title), 1),
          _createElementVNode("small", null, _toDisplayString(_ctx.song.artist), 1)
        ])
      ]),
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("span", _hoisted_5, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.rating.range, (i) => {
            return (_openBlock(), _createElementBlock("svg", {
              class: _normalizeClass(["icon-heart", _ctx.ratedClass(i)]),
              key: i
            }, [
              _createElementVNode("use", {
                href: "#icon-heart",
                mask: _ctx.ratedMask(i)
              }, null, 8, _hoisted_6)
            ], 2))
          }), 128))
        ]),
        (_ctx.currentRating?.avg)
          ? (_openBlock(), _createElementBlock("small", _hoisted_7, _toDisplayString(_ctx.currentRating.avg), 1))
          : _createCommentVNode("", true)
      ]),
      (_ctx.currentRating?.count)
        ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
            _createElementVNode("small", _hoisted_9, _toDisplayString(_ctx.currentRating.count) + " beoordelingen ", 1)
          ]))
        : _createCommentVNode("", true),
      (_ctx.interactive)
        ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
            (!_ctx.isRated)
              ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                  _hoisted_10,
                  _hoisted_11
                ], 64))
              : (_openBlock(), _createElementBlock("svg", _hoisted_12, _hoisted_14))
          ], 64))
        : _createCommentVNode("", true)
    ]),
    (_ctx.interactive)
      ? (_openBlock(), _createElementBlock("dialog", _hoisted_15, [
          _createElementVNode("div", _hoisted_16, [
            _renderSlot(_ctx.$slots, "default", {}, () => [
              _createElementVNode("div", _hoisted_17, [
                _createElementVNode("img", {
                  src: `${_ctx.song.albumart.url}?w=150`,
                  alt: _ctx.song.title
                }, null, 8, _hoisted_18),
                _createElementVNode("div", _hoisted_19, [
                  _createElementVNode("h4", null, _toDisplayString(_ctx.song.title), 1),
                  _createElementVNode("small", null, _toDisplayString(_ctx.song.artist), 1)
                ])
              ])
            ], true),
            _hoisted_20
          ]),
          _createElementVNode("div", _hoisted_21, [
            _createElementVNode("div", _hoisted_22, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.rating.range, (i) => {
                return (_openBlock(), _createElementBlock("svg", {
                  class: "icon-heart",
                  key: i,
                  onClick: ($event: any) => (_ctx.handleRatingSelect(i)),
                  ref_for: true,
                  ref: "rateSelect"
                }, _hoisted_25, 8, _hoisted_23))
              }), 128))
            ])
          ]),
          _createElementVNode("div", _hoisted_26, [
            _createElementVNode("button", {
              type: "button",
              class: "btn--default",
              onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.handleModalClose && _ctx.handleModalClose(...args)))
            }, "annuleer"),
            _createElementVNode("button", {
              type: "submit",
              class: "btn--primary",
              onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.handleSubmit && _ctx.handleSubmit(...args)))
            }, _toDisplayString(_ctx.submitText), 1),
            _createElementVNode("small", null, [
              _hoisted_27,
              (_ctx.isRated && !_ctx.loading)
                ? (_openBlock(), _createElementBlock("span", _hoisted_28, "Bedankt voor jouw beoordeling!"))
                : _createCommentVNode("", true)
            ])
          ])
        ], 512))
      : _createCommentVNode("", true)
  ], 64))
}